'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = require('../constants/action-types');

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {};

var queries = function queries() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actionTypes.RESET:
      {
        return {};
      }
    case actionTypes.MUTATE_START:
    case actionTypes.REQUEST_START:
      {
        var queryKey = action.queryKey;


        return _extends({}, state, _defineProperty({}, queryKey, {
          url: action.url,
          isFinished: false,
          isPending: true,
          networkHandler: action.networkHandler,
          isMutation: action.type === actionTypes.MUTATE_START,
          queryCount: state[queryKey] ? state[queryKey].queryCount + 1 : 1
        }));
      }
    case actionTypes.REQUEST_SUCCESS:
    case actionTypes.MUTATE_FAILURE:
    case actionTypes.MUTATE_SUCCESS:
    case actionTypes.REQUEST_FAILURE:
      {
        var _queryKey = action.queryKey;


        return _extends({}, state, _defineProperty({}, _queryKey, _extends({}, state[_queryKey], {
          isFinished: true,
          isPending: false,
          lastUpdated: action.time,
          status: action.status,
          headers: action.responseHeaders
        })));
      }
    case actionTypes.CANCEL_QUERY:
      {
        var _queryKey2 = action.queryKey;


        if (state[_queryKey2].isPending) {
          // Make sure query is actually pending

          return _extends({}, state, _defineProperty({}, _queryKey2, _extends({}, state[_queryKey2], {
            isFinished: true,
            isPending: false,
            status: 0
          })));
        }

        return state;
      }
    default:
      {
        return state;
      }
  }
};

exports.default = queries;